import { config } from "./index.js";

//#region src/config/env-prd.ts
config.initialize("prd");
config.set((conf) => {
	conf.urls = {
		...conf.urls,
		apiGateway: "https://api.jwplayer.com",
		contentServer: "https://cdn.jwplayer.com"
	};
});

//#endregion
//# sourceMappingURL=env-prd.js.map